import { HttpMethods } from "@/react/http";
import { customerBaseApi } from "@/react/services/api";

const AGENT_ASSIGNMENTS_CACHE_TAG = "agent_assignments";

const agentAssignmentBaseURL = (tenantName) =>
  `tenants/${tenantName}/assignments/agent-queue`;
const agentAssignmentDeleteURL = (tenantName) =>
  `${agentAssignmentBaseURL(tenantName)}/delete`;

export const agentAssignmentApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    createAgentQueueAssignment: build.mutation({
      query: ({ tenantName, payload }) => ({
        url: agentAssignmentBaseURL(tenantName),
        method: HttpMethods.POST,
        body: payload,
      }),
      invalidatesTags: [AGENT_ASSIGNMENTS_CACHE_TAG],
    }),
    findAllAgentQueueAssignmentsForTenant: build.query({
      query: ({ tenantName }) => ({
        url: agentAssignmentBaseURL(tenantName),
        method: HttpMethods.GET,
      }),
      providesTags: [AGENT_ASSIGNMENTS_CACHE_TAG],
    }),
    updateAgentQueueAssignment: build.mutation({
      query: ({ tenantName, payload }) => ({
        url: agentAssignmentBaseURL(tenantName),
        method: HttpMethods.PUT,
        body: payload,
      }),
      invalidatesTags: [AGENT_ASSIGNMENTS_CACHE_TAG],
    }),
    deleteAgentQueueAssignment: build.mutation({
      query: ({ tenantName, payload }) => ({
        url: agentAssignmentDeleteURL(tenantName),
        method: HttpMethods.POST,
        body: payload,
      }),
    }),
    invalidatesTags: [AGENT_ASSIGNMENTS_CACHE_TAG],
  }),
  overrideExisting: false,
});

export const {
  useCreateAgentQueueAssignmentMutation,
  useFindAllAgentQueueAssignmentsForTenantQuery,
  useUpdateAgentQueueAssignmentMutation,
  useDeleteAgentQueueAssignmentMutation,
} = agentAssignmentApi;
